import { addDefaultAttributes } from "./EventsManager";
export let HttpV2Client;
export let authTokenManager;
export let metricsManager;
export let eventsManager;
export let gatherVideoClientDataSource = {
    gate: () => false,
    getAVStrategyMap: () => ({
        base: () => undefined,
        gather: () => undefined,
        livekit: () => undefined,
        livekitselfhost: () => undefined,
    }),
    performance: () => performance,
};
export const registerGlobals = (globals) => {
    HttpV2Client = globals.HttpV2Client;
    authTokenManager = globals.authTokenManager;
    metricsManager = globals.metricsManager;
    eventsManager = addDefaultAttributes(globals.eventsManager, metricsManager.getCurrentCustomAttributes);
    gatherVideoClientDataSource = globals.gatherVideoClientDataSource;
};
//# sourceMappingURL=Globals.js.map